import React from "react";
import "./AboutSection.scss";
import studioImg from '../../../assets/img/about-studio.jpg';

const aboutText = {
  title: "About Studio",
  name: "Hong Kong Architect",
  description: "With Scandinavian roots and a base in Hong Kong, we craft functional, elegant, and tailored environments that reflect each client’s unique vision."
};

export const AboutSection = () => {
  return (
    <section className="about-section">
      <div className="about">
        <div className="about__image">
          <img src={studioImg} alt={`${aboutText.title} - ${aboutText.name}`} />
        </div>
        <div className="about__content">
          <h1 className="about__title">{aboutText.title}</h1>
          <h2 className="about__name">{aboutText.name}</h2>
          <p className="about__description">{aboutText.description}</p>
        </div>
      </div>
    </section>
  );
};
